/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * One cargo placement in the compartment.
 */
export interface CargoPlacementLastmile { 
    /**
     * Compartment key.
     */
    box_key: string;
    /**
     * Cargo key.
     */
    cargo_key: string;
}

